// extracted by mini-css-extract-plugin
var _1 = "ZryZG";
export { _1 as "base" }
